import { createSelector } from 'reselect';

const getRouteParams = (state) => state.currentRoute.params;
const getWorkflowDetail = (state) => state.workflowDetail;
const getWorkflowSteps = (state) => state.workflowStepDetail;

export const workflowDetail = createSelector(
  [getWorkflowDetail, getRouteParams],
  (details, params) => {
    if (!params.workflowId || !(params.workflowId in details.resources)) return {};
    return details.resources[params.workflowId];
  }
);

export const workflowSteps = createSelector(
  [getWorkflowSteps, getRouteParams],
  (steps, params) => {
    if (!params.workflowId) return [];
    return Object.values(steps.resources)
      .filter((step) => step.workflowId === params.workflowId)
      .sort((a, b) => {
        if (!a.name || !b.name || a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
  },
);
